<section class="nimbus-dual-listbox">
  <section class="list-one">
    <label>{{ sourceName }}</label>
    <div
      cdkDropList
      #listOne="cdkDropList"
      [cdkDropListConnectedTo]="[listTwo]"
      class="nimbus-dual-listbox-list"
      (cdkDropListDropped)="addToList($event)"
      [cdkDropListData]="availableItems"
    >
      @for (item of availableItems; track trackItem(index, item); let index = $index) {
        <div cdkDrag (dblclick)="addItem(item)">
          <div nimbusTheme class="nimbus-dual-listbox-list-item">
            <ng-content *ngTemplateOutlet="itemTemplateRef; context: { item: item, index: index }"></ng-content>
          </div>
        </div>
      }
    </div>
  </section>

  <section class="list-two">
    <label class="required-field">{{ selectedName }}</label>
    <div
      cdkDropList
      #listTwo="cdkDropList"
      [cdkDropListConnectedTo]="[listOne]"
      class="nimbus-dual-listbox-list"
      (cdkDropListDropped)="addToList($event)"
      (cdkDropListSorted)="sortList($event)"
      [cdkDropListData]="selectedItems"
    >
      @for (item of selectedItems; track trackItem(index, item); let index = $index) {
        <div cdkDrag (dblclick)="removeItem(item)" class="flex-container flex-align-center-left">
          <div class="list-item-order">{{ index + 1 }}.&nbsp;&nbsp;</div>
          <div nimbusTheme class="nimbus-dual-listbox-list-item flex-grow">
            <ng-content *ngTemplateOutlet="itemTemplateRef; context: { item: item, index: index }"></ng-content>
          </div>
        </div>
      }
      @if (selectedItems.length === 0) {
        <div class="empty-message flex-container">
          <div class="flex-container flex-column flex-align-space-between">
            <div>
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="44px"
                height="42px"
                viewBox="0 0 44 42"
                style="enable-background: new 0 0 44 42"
                xml:space="preserve"
              >
                <style type="text/css">
                  .st0 {
                    fill: none;
                    stroke: #2f3046;
                    stroke-miterlimit: 10;
                  }
                  .st1 {
                    fill: none;
                    stroke: #2f3046;
                    stroke-miterlimit: 10;
                    stroke-dasharray: 4.0063, 4.0063;
                  }
                </style>
                <g>
                  <path
                    class="st0"
                    d="M24.5,27.5h-21c-1.7,0-3-1.3-3-3v-21c0-1.7,1.3-3,3-3h21c1.7,0,3,1.3,3,3v21C27.5,26.2,26.2,27.5,24.5,27.5z"
                  />
                  <g>
                    <g>
                      <line class="st0" x1="27.5" y1="14.5" x2="29.5" y2="14.5" />
                      <path class="st1" d="M33.5,14.5h7c1.7,0,3,1.3,3,3v21c0,1.7-1.3,3-3,3h-21c-1.7,0-3-1.3-3-3v-7" />
                      <line class="st0" x1="16.5" y1="29.5" x2="16.5" y2="27.5" />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div>
              {{ emptyMessage }}
            </div>
          </div>
        </div>
      }
    </div>
  </section>
</section>
<div class="nimbus-dual-listbox-tip">
  <i [nimbusIcon]="icons.INFO_CIRCLE_NEW" iconWeight="regular"></i>
  {{ tipMessage }}
</div>
